const equipmentProfile = {
  area: "Area",
  backbtn: "Go Back",
  chooseADateRange: "Choose A Date Range",
  comment: "Comment",
  createdBy: "Created By",
  customer: "Customer",
  dateCreated: "Date Created",
  deleteEquipment: "Delete Asset",
  equipment: "Asset",
  equipmentStatus: "Asset Status",
  equipmentTag: "Asset Tag",
  equipmentType: "Asset Type",
  goBack: "Go Back",
  hazardous: "Hazardous Area Classification",
  manufacturer: "Manufacturer",
  model: "Model",
  nocomment: "None",
  product: "Product",
  pumpHousing: "Pump Housing",
  responsible: "Select responsible for the asset",
  sealTypes: "Mechanical Seal Types",
  snackText: "Your file has been downloaded into Downloads Folder",
  unit: "Unit",
  updatebtn: "UPDATE ASSET"
};
export default equipmentProfile;
